import { PaymentContainer } from 'src/components/PaymentContainer/PaymentContainer';
import { PaymentGenericError } from 'src/components/PaymentGenericError/PaymentGenericError';
import type { ListingProduct } from 'src/generated/graphql';
import {
  isEmailAndSearchBoostAdPackCombination,
  isEmailAndSearchBoostStandardCombination,
} from 'src/utils/listingProducts';

import { EmailAndSearchBoostPaymentScreen } from './components/PaymentScreens/EmailAndSearchBoostPaymentScreen';
import { StripeProider } from './components/StripeProvider/StripeProvider';

interface PaymentWithSecondProductProps {
  clientId: string;
  firstUrlProduct: ListingProduct;
  secondUrlProduct: ListingProduct;
  singleProducts: {
    freemium: ListingProduct;
    standard: ListingProduct;
    accelerate: ListingProduct;
    searchBoostAdPack: ListingProduct;
    searchBoostStandard: ListingProduct;
    emailBoostAdPack: ListingProduct;
    emailBoostStandard: ListingProduct;
  };
  combinedProducts: {
    standardAndSearchBoost: ListingProduct;
    emailBoostAndSearchBoostAdPack: ListingProduct;
    emailBoostAndSearchBoostStandard: ListingProduct;
  };
  listingId: string | null;
}

export const PaymentWithSecondProduct = (
  props: PaymentWithSecondProductProps,
) => {
  if (
    isEmailAndSearchBoostAdPackCombination(
      props.firstUrlProduct,
      props.secondUrlProduct,
    )
  ) {
    return (
      <PaymentContainer width="medium">
        <StripeProider>
          <EmailAndSearchBoostPaymentScreen
            emailBoostProduct={props.singleProducts.emailBoostAdPack}
            searchBoostProduct={props.singleProducts.searchBoostAdPack}
            emailAndSearchBoostProduct={
              props.combinedProducts.emailBoostAndSearchBoostAdPack
            }
            clientId={props.clientId}
            listingId={props.listingId}
          />
        </StripeProider>
      </PaymentContainer>
    );
  }

  if (
    isEmailAndSearchBoostStandardCombination(
      props.firstUrlProduct,
      props.secondUrlProduct,
    )
  ) {
    return (
      <PaymentContainer width="medium">
        <StripeProider>
          <EmailAndSearchBoostPaymentScreen
            emailBoostProduct={props.singleProducts.emailBoostStandard}
            searchBoostProduct={props.singleProducts.searchBoostStandard}
            emailAndSearchBoostProduct={
              props.combinedProducts.emailBoostAndSearchBoostStandard
            }
            clientId={props.clientId}
            listingId={props.listingId}
          />
        </StripeProider>
      </PaymentContainer>
    );
  }

  // TODO unit test
  return <PaymentGenericError testId="multiple-products-no-match-error" />;
};
